import { createBrowserRouter, redirect } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Inbox from '../pages/Inbox/Inbox';
import Library from '../pages/Library/Library';
import Projects from '../pages/Projects/Projects';
import Scan from '../pages/Scan/Scan';
import Search from '../pages/Search/Search';
import Strategy from '../pages/Strategy/Strategy';
import Layout from '../layout/Layout';
import NoMatch from '../pages/NoMatch/NoMatch';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import EyRnAI from '../pages/EyRnAI/EyRnAI';
import RiskUniverse from '../pages/RiskUniverse/RiskUniverse';


export let router = createBrowserRouter([
    {
        path: "/",
        Component: Layout,
        children: [
            {
                index: true,
                ErrorBoundary: ErrorPage,
                Component: Home,
            },
            {
                path: '/',
                Component: Home,
            },
            {
                path: '/home',
                loader: ()=> redirect("/")
                
            },
            {
                path: 'inbox',
                Component: Inbox,
            },
            {
                path: 'library',
                Component: Library,
            },
            {
                path: 'projects',
                Component: Projects,
            },
            {
                path: 'scan',
                Component: Scan,
            },
            {
                path: 'search',
                Component: Search,
            },
            {
                path: 'eyrnai',
                Component: EyRnAI,
            },
            {
                path: 'strategy',
                Component: Strategy,
            },
            {
                path: 'risk-universe',
                Component: RiskUniverse,
            },
            {
                path: '*',
                loader: () => redirect("/")
                // Component: NoMatch,
            },
        ],
    },
]);